"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
/**
 * Removes `undefined` values by parsing to a JSON string and then back to a plain JavaScript object
 * Also removes any "key" or "id" properties
 */
function cleanForFirestore(object) {
    const newObject = (0, cloneDeep_1.default)(object);
    // remove undefined values
    for (const key in newObject) {
        if (Object.prototype.hasOwnProperty.call(newObject, key)) {
            if (newObject[key] === undefined) {
                delete newObject[key];
            }
        }
    }
    // remove id
    if (newObject.id) {
        delete newObject.id;
    }
    // remove key
    if (newObject.key) {
        delete newObject.key;
    }
    return newObject;
}
exports.default = cleanForFirestore;
